<template>
  <div id="printBodyCertificate">
    <table class="table table-sm table-borderless">
      <tr class="text-center border-bottom">
        <td colspan="2">
          <template><strong>{{org.name}}</strong></template>
        </td>
      </tr>
      <tr class="text-center">
        <td colspan="2">
          <small class="text-muted">Наименование организации</small>
        </td>
      </tr>

      <tr class="text-center border-bottom">
        <td colspan="2">
          <template>{{org.zip + ', ' + org.country + ', ' + org.region + ', ' + org.city + ', ' + org.address}}</template>
        </td>
      </tr>
      <tr class="text-center">
        <td colspan="2">
          <small class="text-muted">Полный почтовый адрес</small>
        </td>
      </tr>

      <tr class="border-bottom">
        <td width="50%">
          ИИН/БИН налогоплательщика: <strong>{{org.iinbin}}</strong>
        </td>
        <td width="50%">
          Дата выдачи: <strong>{{new Date(params.date).toLocaleDateString()}}</strong>
        </td>
      </tr>
    </table>
    <h4 class="text-center">Справка о зарплате № <span v-if="params.number == 0">______</span><span v-else>{{params.number}}</span></h4>

    <table class="table table-borderless table-sm mt-3">
      <tr class="border-bottom">
        <td>дана в том, что <strong>{{worker.last_name + ' ' + worker.first_name + ' ' + worker.middle_name}}, ИИН {{worker.iin}}</strong></td>
      </tr>
      <tr class="border-bottom">
        <td>работает в <strong>{{org.name}}</strong></td>
      </tr>
      <tr class="border-bottom">
        <td>в качестве <strong>{{worker.workerfunction}}</strong></td>
      </tr>
      <tr class="border-bottom">
        <td>за период с <strong>{{getMonthName(params.period.from.month) + ' ' + params.period.from.year + ' г.'}}</strong> по <strong>{{getMonthName(params.period.to.month) + ' ' + params.period.to.year + ' г.'}}</strong> его (ее) заработок составил:</td>
      </tr>
    </table>

    <table class="table table-sm table-bordered table-print table-14" v-if="result.list.length > 0">
      <tbody>
      <tr>
        <th>Месяц</th>
        <th width="12%">Сумма заработка</th>
        <th width="12%">Обязательные пенсионные взносы</th>
        <th width="12%">Индивидуальный подоходный налог</th>
        <th width="12%">Взносы ОСМС</th>
        <th width="12%">Удержания</th>
        <th width="12%">Итого к выплате работнику</th>
      </tr>

      <template v-for="(item, index) in result.list">
        <tr :key="index">
          <td>{{getMonthName(item.month) + ' ' + item.year}}</td>
          <td>{{item.amount_res_sum}}</td>
          <td>{{item.amount_res_opv}}</td>
          <td>{{item.amount_res_ipn}}</td>
          <td>{{item.amount_res_vosms}}</td>
          <td>{{item.amount_res_deduction}}</td>
          <td>{{item.amount_res_worker}}</td>
        </tr>

      </template>
      <tr class="bg-light">
        <td>ИТОГО</td>
        <td>{{getAmountField(result.list, 'amount_res_sum')}}</td>
        <td>{{getAmountField(result.list, 'amount_res_opv')}}</td>
        <td>{{getAmountField(result.list, 'amount_res_ipn')}}</td>
        <td>{{getAmountField(result.list, 'amount_res_vosms')}}</td>
        <td>{{getAmountField(result.list, 'amount_res_deduction')}}</td>
        <td>{{getAmountField(result.list, 'amount_res_worker')}}</td>
      </tr>
      </tbody>
    </table>

    <p>Справка дана для предоставления в <strong>{{params.destination}}</strong></p>

    <Signature :org="org"></Signature>

  </div>
</template>


<script>
import Signature from "@/components/print/parts/Signature"
export default {
  components: {
    Signature
  },
  props: ['result', 'org', 'worker', 'params']
}
</script>


<style>

</style>
